"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    INVALID_USER: {
        code: '085001',
        httpStatus: 404,
        description: 'User does not exists in dodrio',
        displayToUser: false,
        isRetryable: false,
    },
    USER_NOT_FOUND: {
        code: '085002',
        httpStatus: 404,
        description: 'User does not exists in dodrio',
        displayToUser: false,
        isRetryable: false,
    },
    TIER_INFORMATION_NOT_FOUND: {
        code: '085003',
        httpStatus: 404,
        errorLevel: 'verbose',
        description: 'Tier information not found',
        displayToUser: false,
        isRetryable: false,
    },
    TIER_HISTORY_NOT_FOUND: {
        code: '085004',
        httpStatus: 404,
        description: 'Tier history not found',
        displayToUser: false,
        isRetryable: false,
    },
    ONFIDO_DATA_NOT_FOUND: {
        code: '085005',
        httpStatus: 404,
        description: 'Onfido data not found',
        displayToUser: false,
        isRetryable: false,
    },
    TIER_ALREADY_VERIFIED: {
        code: '085006',
        httpStatus: 403,
        errorLevel: 'warn',
        description: 'User tier already verified',
        displayToUser: false,
        isRetryable: false,
    },
    TIER_ALREADY_ENHANCED: {
        code: '085007',
        httpStatus: 403,
        description: 'User already on max tier',
        displayToUser: false,
        isRetryable: false,
    },
    VERIFICATION_IN_PROGRESS: {
        code: '085008',
        httpStatus: 422,
        errorLevel: 'warn',
        description: 'Verification already in progress',
        displayToUser: false,
        isRetryable: false,
    },
    VERIFICATION_IN_MANUAL_REVIEW: {
        code: '085009',
        httpStatus: 433,
        description: 'Verification is in manual review',
        displayToUser: false,
        isRetryable: false,
    },
    ONFIDO_USER_REGISTRATION_FAILED: {
        code: '085010',
        httpStatus: 400,
        description: 'Failed to register applicant in onfido',
        displayToUser: true,
        isRetryable: false,
    },
    DUPLICATE_USER: {
        code: '085011',
        httpStatus: 400,
        description: 'Duplicate user registration',
        displayToUser: false,
        isRetryable: false,
    },
    EXTERNAL_USER_NOT_FOUND: {
        code: '085012',
        httpStatus: 404,
        description: 'External user not found',
        displayToUser: false,
        isRetryable: false,
    },
    UNSOPPORTED_PROVIDER: {
        code: '085013',
        httpStatus: 422,
        description: 'Unsopported provider',
        displayToUser: false,
        isRetryable: false,
    },
    PROVIDER_NOT_FOUND: {
        code: '085014',
        httpStatus: 404,
        description: 'Provider not found',
        displayToUser: false,
        isRetryable: false,
    },
    REQUIRED_REPORTS_NOT_FOUND: {
        code: '085015',
        httpStatus: 404,
        description: 'Required reports not found',
        displayToUser: false,
        isRetryable: false,
    },
    ONIX_USER_NOT_FOUND: {
        code: '085017',
        httpStatus: 404,
        description: 'Onix user not found',
        displayToUser: false,
        isRetryable: false,
    },
    USER_NOT_VERIFIED: {
        code: '085018',
        httpStatus: 403,
        description: 'User not verified',
        displayToUser: false,
        isRetryable: false,
    },
    USER_ENHANCED_VERIFIED: {
        code: '085019',
        httpStatus: 403,
        description: 'User already with enhanced verification',
        displayToUser: false,
        isRetryable: false,
    },
    UPDATE_PHONE_UNMATCH: {
        code: '085020',
        httpStatus: 400,
        description: 'Phone does not match with the previous registered',
        displayToUser: false,
        isRetryable: false,
    },
    INVALID_USER_STATUS: {
        code: '085021',
        httpStatus: 400,
        description: 'Invalid user status',
        displayToUser: false,
        isRetryable: false,
    },
    USER_PROVIDER_NOT_FOUND: {
        code: '085022',
        httpStatus: 404,
        description: 'User provider relationship not found',
        displayToUser: false,
        isRetryable: false,
        errorLevel: 'verbose',
    },
    ERROR_WATCHLIST_UPSERT: {
        code: '085023',
        httpStatus: 500,
        description: 'Error upserting watchlist records in batch',
        displayToUser: false,
        isRetryable: false,
    },
    ERROR_WATCHLIST_CHECK: {
        code: '085024',
        httpStatus: 500,
        description: 'Error when matching user against OFAC - SDN list',
        displayToUser: false,
        isRetryable: false,
    },
    ERROR_LOGIN_USER_WHITELISTED: {
        code: '085025',
        httpStatus: 500,
        description: 'Error when trying to store login information of whitelisted user',
        displayToUser: false,
        isRetryable: false,
    },
    KOUNT_CONTROL_SERVER_ERROR: {
        code: '085026',
        httpStatus: 500,
        // eslint-disable-next-line no-useless-escape
        description: `¯\_(⊙︿⊙)_/¯ Kount Control internal server error`,
        displayToUser: false,
        isRetryable: false,
    },
    USER_ALREADY_REGISTERED_IN_ONFIDO: {
        code: '085027',
        httpStatus: 400,
        description: 'User already registered in Onfido',
        displayToUser: false,
        isRetryable: false,
    },
    PARTIAL_VERIFICATION_REQUIRED: {
        code: '085028',
        httpStatus: 400,
        description: 'User must be partial verified',
        displayToUser: false,
        isRetryable: false,
    },
    WATCHLIST_ALREADY_VERIFIED: {
        code: '085029',
        httpStatus: 400,
        description: 'Watchlist report already verified',
        displayToUser: false,
        isRetryable: false,
    },
    NO_VERIFICATION_IN_PROGRESS: {
        code: '085030',
        httpStatus: 400,
        description: 'There is not verification in progress',
        displayToUser: false,
        isRetryable: false,
    },
    EMAIL_IN_USE: {
        code: '085031',
        httpStatus: 400,
        description: 'Email belongs to another user',
        displayToUser: false,
        isRetryable: false,
    },
    KOUNT_CONTROL_INVALID_REQUEST: {
        code: '085032',
        httpStatus: 422,
        description: 'щ（ﾟДﾟщ） invalid data sent to Kount Control',
        displayToUser: false,
        isRetryable: false,
    },
    INVALID_USER_FOR_SEND_FEE: {
        code: '085033',
        httpStatus: 422,
        description: `This user cant apply for send fees`,
        displayToUser: false,
        isRetryable: false,
    },
    NO_MOBILE_PIN_FOUND: {
        code: '085034',
        httpStatus: 400,
        description: `User has no mobile PIN configured`,
        displayToUser: true,
        isRetryable: false,
    },
    INVALID_MOBILE_PIN: {
        code: '085035',
        httpStatus: 401,
        description: `Incorrect mobile PIN`,
        displayToUser: true,
        isRetryable: false,
    },
    KOUNT_CONTROL_FAKE_SESSION_ID_ON_SIGNUP: {
        code: '085034',
        httpStatus: 403,
        description: 'SessionId was not found in Kount, blocking signup',
        displayToUser: false,
    },
    INVALID_REQUEST: {
        code: '085036',
        httpStatus: 400,
        description: 'Invalid request',
        displayToUser: true,
        isRetryable: false,
    },
    BANNED_COUNTRY: {
        code: '085037',
        httpStatus: 400,
        description: 'Banned country',
        displayToUser: false,
        isRetryable: false,
    },
    INVALID_MOBILE_BIOMETRICS: {
        code: '085038',
        httpStatus: 401,
        description: `Incorrect mobile biometrics`,
        displayToUser: true,
        isRetryable: false,
    },
    NO_MOBILE_BIOMETRICS_FOUND: {
        code: '085039',
        httpStatus: 400,
        description: `User has no mobile biometrics configured`,
        displayToUser: true,
        isRetryable: false,
    },
    INVALID_FACEBOOK_CONFIG: {
        errorLevel: 'critical',
        httpStatus: 503,
        description: 'Attempted to login with facebook without App ID and secret set',
        isRetryable: false,
        displayToUser: false,
    },
    USER_DOES_NOT_HAVE_ENTERPRISE_ROLE: {
        code: '085040',
        httpStatus: 403,
        description: 'User does not have enterprise role, blocking login',
        displayToUser: false,
    },
    ONLY_USER_CAN_SELF_DELETE_THEIR_ACCOUNT: {
        code: '085041',
        httpStatus: 403,
        description: 'Only the user can self-delete their own account',
        displayToUser: false,
    },
    USER_BALANCE_MUST_BE_ZERO_TO_DELETE_ACCOUNT: {
        code: '085042',
        httpStatus: 403,
        description: 'Balance needs to be $0 to delete account',
        displayToUser: true,
    },
    USER_HAS_BEEN_BANNED_AND_CANNOT_DELETE_ACCOUNT: {
        code: '085043',
        httpStatus: 403,
        description: 'User has been banned and cannot delete account',
        displayToUser: true,
    },
    USER_CANNOT_HAVE_PENDING_TRANSACTIONS_TO_DELETE_ACCOUNT: {
        code: '085044',
        httpStatus: 403,
        description: 'User cannot have pending transactions to delete account',
        displayToUser: true,
    },
    PASSWORD_PROTECT_DUPLICATION_ERROR: {
        code: '085045',
        httpStatus: 422,
        description: 'Password cannot be the same as one of the 20 previous ones.',
        displayToUser: true,
    },
    MFA_RECOVERY_CODE_NOT_FOUND: {
        code: '085046',
        httpStatus: 404,
        description: 'MFA recovery code not found',
        displayToUser: true,
    },
    MFA_RECOVERY_CODE_INVALID: {
        code: '085047',
        httpStatus: 400,
        description: 'MFA recovery code invalid',
        displayToUser: true,
    },
};
